// extracted by mini-css-extract-plugin
module.exports = {"container":"faq__container___1tCxm","item":"faq__item___2tlrL","content":"faq__content___3O-Rw","answer":"faq__answer___21QcG","isOpen":"faq__isOpen___2-ENw"};